import {
    Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { UrlApi } from "../../../../../services/apirest";

function DialogSelectProductos({
  isModalVisible,
  toggleModal,
  handleProductSelect,
  selectedProductIds,
  addSelectedProducts,
}) {
  const [productos, setProductos] = useState([]);
  const getProductos = async () => {
    try {
      const response = await fetch(`${UrlApi}/productos/envasados`);
      const data = await response.json();
      setProductos(data);
    } catch (error) {
      console.error("Error obteniendo productos:", error);
    }
  };

  useEffect(() => {
    getProductos();
  }, []);

  return (
    <Dialog open={isModalVisible} onClose={toggleModal} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Seleccionar Productos</Typography>
        <IconButton onClick={toggleModal}>
          <CloseIcon />
        </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <List>
          {productos.map((product) => (
            <ListItem
              key={product.idproducto}
              button
              onClick={() => handleProductSelect(product)}
            >
              <Checkbox
                checked={selectedProductIds.has(product.idproducto)}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText primary={product.nombre} />
              {selectedProductIds.has(product.idproducto) && (
                <CheckIcon color="primary" />
              )}
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={toggleModal}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={addSelectedProducts}
          disabled={selectedProductIds.size === 0}
        >
          Agregar Productos ({selectedProductIds.size})
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogSelectProductos;
